class OrderOnline extends HTMLElement {
  connectedCallback() {
    if (this.ready) {
      this.timer = setInterval(() => this.update(), 60000);
      return;
    }
    this.ready = true;
    this.root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    this.locale = this.dataset.locale || 'en';
    this.tz = this.dataset.timezone || 'America/Los_Angeles';
    this.fmt = new Intl.NumberFormat(this.locale, { style: 'currency', currency: this.dataset.currency || 'USD' });
    this.leads = { Pickup: Number(this.dataset.pickupLead) || 20, Delivery: Number(this.dataset.deliveryLead) || 45 };
    this.leadMin = { Pickup: this.leads.Pickup, Delivery: Math.min(Number(this.dataset.deliveryMin) || 20, this.leads.Delivery) };
    this.hours = (this.dataset.hours || '').split('|').map((h) => {
      const m = /^([0-9]{1,2}):([0-9]{2}) *- *([0-9]{1,2}):([0-9]{2})$/.exec(h.trim());
      return m ? { open: Number(m[1]) * 60 + Number(m[2]), close: Number(m[3]) * 60 + Number(m[4]) } : null;
    });
    this.mode = 'Pickup';
    this.when = 'asap';
    this.date = null;
    this.time = null;
    this.cartEmpty = true;
    this.canOrder = false;
    this.chain = Promise.resolve();
    this.products = new Map();
    this.cart = null;
    this.dialog = this.querySelector('.oo-dialog');
    this.drawer = this.querySelector('.oo-drawer');
    this.calDialog = this.querySelector('.oo-cal');
    this.bar = this.querySelector('.oo-bar');
    this.toast = this.querySelector('.oo-toast');
    this.renderHours();
    this.bindMode();
    this.bindWhen();
    this.bindNav();
    this.bindDialogs();
    this.initCategories();
    this.update();
    this.refreshCart();
    this.timer = setInterval(() => this.update(), 60000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, (c) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    })[c]);
  }

  money(value) {
    return this.fmt.format(Number(value));
  }

  cents(value) {
    return this.fmt.format(value / 100);
  }

  plain(html) {
    return (new DOMParser().parseFromString(html || '', 'text/html').body.textContent || '').trim();
  }

  img(src, width) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  say(message) {
    this.toast.textContent = message;
    this.toast.classList.add('is-visible');
    clearTimeout(this.toastTimer);
    this.toastTimer = setTimeout(() => this.toast.classList.remove('is-visible'), 2800);
  }

  now() {
    const opts = { hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' };
    let parts;
    try {
      parts = new Intl.DateTimeFormat('en-CA', Object.assign({ timeZone: this.tz }, opts)).formatToParts(new Date());
    } catch (error) {
      parts = new Intl.DateTimeFormat('en-CA', opts).formatToParts(new Date());
    }
    const get = (type) => parts.find((p) => p.type === type).value;
    return { key: get('year') + '-' + get('month') + '-' + get('day'), min: Number(get('hour')) * 60 + Number(get('minute')) };
  }

  dow(key) {
    return new Date(key + 'T00:00:00Z').getUTCDay();
  }

  addDays(key, n) {
    const d = new Date(key + 'T00:00:00Z');
    d.setUTCDate(d.getUTCDate() + n);
    return d.toISOString().slice(0, 10);
  }

  dayLabel(key, opts) {
    return new Date(key + 'T00:00:00Z').toLocaleDateString(this.locale, Object.assign({ timeZone: 'UTC' }, opts));
  }

  clock(min) {
    const h = Math.floor(min / 60);
    const m = min % 60;
    return (h % 12 || 12) + (m ? ':' + String(m).padStart(2, '0') : '') + ' ' + (h >= 12 ? 'PM' : 'AM');
  }

  clock24(min) {
    return String(Math.floor(min / 60)).padStart(2, '0') + ':' + String(min % 60).padStart(2, '0');
  }

  lead() {
    return this.leads[this.mode];
  }

  etaText() {
    const lo = this.leadMin[this.mode];
    const hi = this.leads[this.mode];
    return lo === hi ? hi + ' min' : lo + '–' + hi + ' min';
  }

  slots(key) {
    const h = this.hours[this.dow(key)];
    const now = this.now();
    if (!h || key < now.key) return [];
    let start = h.open;
    if (key === now.key) start = Math.max(start, Math.ceil((now.min + this.lead()) / 15) * 15);
    const out = [];
    for (let t = start; t <= h.close - 15; t += 15) out.push(t);
    return out;
  }

  openDays() {
    const today = this.now().key;
    const out = [];
    for (let i = 0; i < 14; i++) {
      const key = this.addDays(today, i);
      if (this.slots(key).length) out.push(key);
    }
    return out;
  }

  asapOk() {
    const n = this.now();
    const h = this.hours[this.dow(n.key)];
    return !!h && n.min >= h.open && n.min + this.lead() <= h.close;
  }

  status() {
    const n = this.now();
    const h = this.hours[this.dow(n.key)];
    if (h && n.min >= h.open && n.min < h.close) return 'Open today until ' + this.clock(h.close);
    if (h && n.min < h.open) return 'Opens today at ' + this.clock(h.open);
    for (let i = 1; i < 8; i++) {
      const key = this.addDays(n.key, i);
      const d = this.hours[this.dow(key)];
      if (d) return 'Closed now · opens ' + (i === 1 ? 'tomorrow' : this.dayLabel(key, { weekday: 'long' })) + ' at ' + this.clock(d.open);
    }
    return 'Closed';
  }

  describe() {
    if (this.when === 'asap') return 'ASAP (about ' + this.etaText() + ')';
    if (this.date && this.time != null) return this.dayLabel(this.date, { weekday: 'short', month: 'short', day: 'numeric' }) + ' at ' + this.clock(this.time);
    return 'No time selected';
  }

  orderLabel() {
    return this.mode + ' · ' + this.describe();
  }

  renderHours() {
    const names = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    this.querySelector('.oo-hours-list').innerHTML = this.hours.map((h, i) =>
      `<li data-dow='${i}'><span>${names[i]}</span><span>${h ? this.clock(h.open) + ' – ' + this.clock(h.close) : 'Closed'}</span></li>`
    ).join('');
  }

  update() {
    const asapOk = this.asapOk();
    const days = this.openDays();
    const today = this.now();
    if (this.when === 'asap' && !asapOk) this.when = 'later';
    if (this.when === 'later') {
      if (!this.date || days.indexOf(this.date) === -1) this.date = days[0] || null;
      const list = this.date ? this.slots(this.date) : [];
      if (list.indexOf(this.time) === -1) this.time = list.length ? list[0] : null;
    }
    const lead = this.lead();
    this.querySelector('[data-status]').textContent = this.status();
    const asapBtn = this.querySelector('[data-when="asap"]');
    asapBtn.disabled = !asapOk;
    asapBtn.textContent = (this.mode === 'Pickup' ? 'ASAP · ready in ~' : 'ASAP · ') + this.etaText();
    this.querySelectorAll('[data-when]').forEach((b) => b.setAttribute('aria-checked', String(b.dataset.when === this.when)));
    const schedule = this.querySelector('.oo-schedule');
    schedule.hidden = this.when !== 'later';
    const select = this.querySelector('.oo-time');
    const list = this.date ? this.slots(this.date) : [];
    select.innerHTML = list.map((t) => `<option value='${t}'${t === this.time ? ' selected' : ''}>${this.clock(t)}</option>`).join('');
    select.disabled = !list.length;
    this.querySelector('[data-date-label]').textContent = this.date
      ? this.dayLabel(this.date, { weekday: 'short', month: 'short', day: 'numeric' }) + (this.date === today.key ? ' (today)' : '')
      : 'No times available';
    this.querySelector('[data-mode-note]').textContent = this.mode === 'Pickup'
      ? (this.dataset.address ? 'Pickup at ' + this.dataset.address + '. ' : '') + 'Orders take about ' + lead + ' minutes to prepare.'
      : 'Delivery takes about ' + this.etaText().replace(' min', ' minutes') + '. Fees are shown at checkout.';
    this.querySelector('.oo-drawer-mode').textContent = this.orderLabel();
    this.querySelectorAll('.oo-hours-list li').forEach((li) => li.classList.toggle('is-today', Number(li.dataset.dow) === this.dow(today.key)));
    this.canOrder = this.when === 'asap' ? asapOk : (this.date != null && this.time != null);
    this.syncCheckout();
  }

  syncCheckout() {
    const btn = this.querySelector('.oo-checkout');
    btn.disabled = this.cartEmpty || !this.canOrder;
  }

  queueSync() {
    this.chain = this.chain.then(() => this.doSync()).catch(() => {});
    return this.chain;
  }

  async getCart() {
    const res = await fetch(this.root + 'cart.js');
    return res.ok ? res.json() : null;
  }

  async doSync() {
    if (!this.canOrder) return;
    const label = this.orderLabel();
    const asap = this.when === 'asap';
    const prefix = 'Order: ';
    const json = { 'Content-Type': 'application/json' };
    let cart = await this.getCart();
    if (!cart || !cart.items.length) return;
    const rest = (cart.note || '').split('\n').filter((l) => l.indexOf(prefix) !== 0).join('\n').trim();
    await fetch(this.root + 'cart/update.js', {
      method: 'POST',
      headers: json,
      body: JSON.stringify({
        note: prefix + label + (rest ? '\n' + rest : ''),
        attributes: {
          'Order type': this.mode,
          'Requested for': this.describe(),
          'Requested date': asap ? this.now().key : this.date,
          'Requested time': asap ? 'ASAP' : this.clock24(this.time)
        }
      })
    });
    for (let i = 0; i < 20; i++) {
      cart = await this.getCart();
      if (!cart) break;
      const idx = cart.items.findIndex((it) => !it.properties || it.properties['Order for'] !== label);
      if (idx < 0) break;
      const item = cart.items[idx];
      await fetch(this.root + 'cart/change.js', {
        method: 'POST',
        headers: json,
        body: JSON.stringify({ line: idx + 1, quantity: item.quantity, properties: Object.assign({}, item.properties, { 'Order for': label }) })
      });
    }
    await this.refreshCart();
  }

  bindMode() {
    this.querySelectorAll('[data-mode]').forEach((button) => {
      button.addEventListener('click', () => {
        this.setMode(button.dataset.mode);
        this.queueSync();
      });
    });
  }

  setMode(mode) {
    this.mode = mode;
    this.querySelectorAll('[data-mode]').forEach((button) => {
      button.setAttribute('aria-checked', String(button.dataset.mode === mode));
    });
    this.update();
  }

  bindWhen() {
    this.querySelectorAll('[data-when]').forEach((b) => {
      b.addEventListener('click', () => {
        if (b.disabled) return;
        this.when = b.dataset.when;
        this.update();
        this.queueSync();
      });
    });
    this.querySelector('[data-open-cal]').addEventListener('click', () => this.openCalendar());
    this.querySelector('.oo-time').addEventListener('change', (e) => {
      this.time = Number(e.target.value);
      this.update();
      this.queueSync();
    });
    this.calDialog.addEventListener('click', (e) => {
      const day = e.target.closest('[data-day]');
      if (day && !day.disabled) {
        this.date = day.dataset.day;
        this.when = 'later';
        this.time = null;
        this.calDialog.close();
        this.update();
        this.queueSync();
        return;
      }
      if (e.target.closest('[data-cal-prev]')) this.shiftMonth(-1);
      else if (e.target.closest('[data-cal-next]')) this.shiftMonth(1);
    });
  }

  openCalendar() {
    const base = this.date || this.now().key;
    this.cal = { y: Number(base.slice(0, 4)), m: Number(base.slice(5, 7)) - 1 };
    this.renderCalendar();
    this.calDialog.showModal();
  }

  shiftMonth(delta) {
    const t = this.cal.y * 12 + this.cal.m + delta;
    this.cal = { y: Math.floor(t / 12), m: t % 12 };
    this.renderCalendar();
  }

  renderCalendar() {
    const days = this.openDays();
    const first = days[0] || this.now().key;
    const last = days[days.length - 1] || first;
    const y = this.cal.y;
    const m = this.cal.m;
    const monthStart = new Date(Date.UTC(y, m, 1));
    this.querySelector('[data-cal-title]').textContent = monthStart.toLocaleDateString(this.locale, { month: 'long', year: 'numeric', timeZone: 'UTC' });
    const blanks = monthStart.getUTCDay();
    const total = new Date(Date.UTC(y, m + 1, 0)).getUTCDate();
    let html = '';
    for (let i = 0; i < blanks; i++) html += '<span></span>';
    for (let d = 1; d <= total; d++) {
      const key = y + '-' + String(m + 1).padStart(2, '0') + '-' + String(d).padStart(2, '0');
      const ok = days.indexOf(key) > -1;
      html += `<button type='button' class='oo-day${key === this.date ? ' is-selected' : ''}' data-day='${key}'${ok ? '' : ' disabled'}>${d}</button>`;
    }
    this.querySelector('.oo-cal-grid').innerHTML = html;
    const index = y * 12 + m;
    this.querySelector('[data-cal-prev]').disabled = index <= Number(first.slice(0, 4)) * 12 + Number(first.slice(5, 7)) - 1;
    this.querySelector('[data-cal-next]').disabled = index >= Number(last.slice(0, 4)) * 12 + Number(last.slice(5, 7)) - 1;
  }

  async checkout() {
    const before = this.describe();
    this.update();
    if (!this.canOrder) {
      this.say('Please choose a time first.');
      return;
    }
    if (before !== this.describe()) {
      this.say('Your time changed to ' + this.describe() + '. Please review and check out again.');
      return;
    }
    await this.queueSync();
    window.location.href = this.root + 'checkout';
  }

  bindNav() {
    const links = new Map();
    this.querySelectorAll('.oo-nav a').forEach((a) => links.set(a.dataset.target, a));
    const spy = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        links.forEach((a) => a.classList.remove('is-active'));
        const active = links.get(entry.target.id);
        if (active) {
          active.classList.add('is-active');
          active.scrollIntoView({ inline: 'center', block: 'nearest' });
        }
      });
    }, { rootMargin: '-25% 0px -65% 0px' });
    this.querySelectorAll('.oo-cat').forEach((section) => spy.observe(section));
  }

  bindDialogs() {
    this.bar.addEventListener('click', () => this.drawer.showModal());
    [this.dialog, this.drawer, this.calDialog].forEach((dlg) => {
      dlg.addEventListener('click', (event) => {
        if (event.target === dlg || event.target.closest('[data-close]')) dlg.close();
      });
    });
    this.drawer.addEventListener('click', (event) => {
      const button = event.target.closest('[data-line]');
      if (!button) return;
      this.changeLine(Number(button.dataset.line), Number(button.dataset.qty));
    });
    this.querySelector('.oo-checkout').addEventListener('click', () => this.checkout());
  }

  initCategories() {
    this.querySelectorAll('.oo-cat').forEach((el) => {
      const cat = {
        el,
        handle: el.dataset.handle,
        grid: el.querySelector('.oo-grid'),
        sentinel: el.querySelector('.oo-sentinel'),
        page: 1,
        count: 0,
        done: false,
        loading: false,
        seen: new Set()
      };
      cat.observer = new IntersectionObserver((entries) => {
        if (entries.some((e) => e.isIntersecting)) this.load(cat);
      }, { rootMargin: '700px 0px' });
      cat.observer.observe(cat.sentinel);
    });
  }

  async load(cat) {
    if (cat.loading || cat.done) return;
    cat.loading = true;
    try {
      const res = await fetch(this.root + 'collections/' + cat.handle + '/products.json?limit=12&page=' + cat.page);
      if (!res.ok) throw new Error('missing');
      const data = await res.json();
      const items = data.products || [];
      if (cat.page === 1) cat.grid.innerHTML = '';
      items.forEach((product) => {
        if (cat.seen.has(product.id)) return;
        cat.seen.add(product.id);
        cat.count += 1;
        this.products.set(product.id, product);
        cat.grid.appendChild(this.card(product));
      });
      if (items.length < 12) cat.done = true;
      cat.page += 1;
    } catch (error) {
      cat.done = true;
    }
    if (cat.done) {
      cat.observer.disconnect();
      if (!cat.count) {
        cat.el.hidden = true;
        const link = this.querySelector('.oo-nav a[data-target="' + cat.el.id + '"]');
        if (link) link.hidden = true;
      }
    } else {
      cat.observer.unobserve(cat.sentinel);
      cat.observer.observe(cat.sentinel);
    }
    cat.loading = false;
  }

  priceLabel(product) {
    const prices = product.variants.map((v) => Number(v.price));
    const min = Math.min.apply(null, prices);
    const max = Math.max.apply(null, prices);
    return (min === max ? '' : 'From ') + this.money(min);
  }

  card(product) {
    const soldOut = !product.variants.some((v) => v.available);
    const single = product.variants.length === 1;
    const image = product.images && product.images[0] ? product.images[0].src : '';
    const article = document.createElement('article');
    article.className = 'oo-card' + (soldOut ? ' is-sold-out' : '');
    article.innerHTML =
      '<button type="button" class="oo-card-main" data-open="' + product.id + '"' + (soldOut ? ' disabled' : '') + '>' +
        '<span class="oo-card-text">' +
          '<h3>' + this.esc(product.title) + '</h3>' +
          '<span class="oo-desc">' + this.esc(this.plain(product.body_html).slice(0, 110)) + '</span>' +
          '<span class="oo-price">' + (soldOut ? 'Sold out' : this.priceLabel(product)) + '</span>' +
        '</span>' +
        (image ? '<span class="oo-card-img"><img loading="lazy" alt="" src="' + this.esc(this.img(image, 360)) + '"></span>' : '') +
      '</button>' +
      (soldOut ? '' : '<button type="button" class="oo-plus" aria-label="Add ' + this.esc(product.title) + '">+</button>');
    article.querySelector('.oo-card-main').addEventListener('click', () => this.openItem(product.id));
    const plus = article.querySelector('.oo-plus');
    if (plus) {
      plus.addEventListener('click', () => {
        if (single) this.add([{ id: product.variants[0].id, quantity: 1 }]);
        else this.openItem(product.id);
      });
    }
    return article;
  }

  openItem(id) {
    const product = this.products.get(id);
    if (!product) return;
    const variants = product.variants.filter((v) => v.available);
    const multi = product.variants.length > 1;
    const image = product.images && product.images[0] ? product.images[0].src : '';
    const body = this.querySelector('.oo-dialog-body');
    body.innerHTML =
      (image ? '<img class="oo-dialog-img" alt="" src="' + this.esc(this.img(image, 900)) + '">' : '') +
      '<div class="oo-dialog-text">' +
        '<h2>' + this.esc(product.title) + '</h2>' +
        '<p class="oo-dialog-desc">' + this.esc(this.plain(product.body_html)) + '</p>' +
        (multi ? '<fieldset class="oo-options"><legend>Choose one</legend>' + variants.map((v, i) =>
          '<label><input type="radio" name="oo-variant" value="' + v.id + '" data-price="' + v.price + '"' + (i === 0 ? ' checked' : '') + '>' +
          '<span>' + this.esc(v.title) + '</span><span>' + this.money(v.price) + '</span></label>').join('') + '</fieldset>' : '') +
        '<label class="oo-notes"><span>Special instructions</span><textarea rows="2" maxlength="200" placeholder="Allergies, extra crispy, no onions..."></textarea></label>' +
        '<div class="oo-add-row">' +
          '<div class="oo-qty"><button type="button" data-step="-1" aria-label="Fewer">&minus;</button><output>1</output><button type="button" data-step="1" aria-label="More">+</button></div>' +
          '<button type="button" class="oo-add-btn"></button>' +
        '</div>' +
      '</div>';
    const output = body.querySelector('output');
    const addBtn = body.querySelector('.oo-add-btn');
    const unit = () => {
      const chosen = body.querySelector('input[name="oo-variant"]:checked');
      return chosen ? Number(chosen.dataset.price) : Number(variants[0].price);
    };
    const refresh = () => {
      addBtn.textContent = 'Add to order · ' + this.money(unit() * Number(output.textContent));
    };
    body.querySelectorAll('[data-step]').forEach((button) => {
      button.addEventListener('click', () => {
        output.textContent = Math.min(20, Math.max(1, Number(output.textContent) + Number(button.dataset.step)));
        refresh();
      });
    });
    body.querySelectorAll('input[name="oo-variant"]').forEach((input) => input.addEventListener('change', refresh));
    addBtn.addEventListener('click', async () => {
      const chosen = body.querySelector('input[name="oo-variant"]:checked');
      const note = body.querySelector('textarea').value.trim();
      const item = { id: chosen ? Number(chosen.value) : variants[0].id, quantity: Number(output.textContent) };
      if (note) item.properties = { Notes: note };
      addBtn.disabled = true;
      const ok = await this.add([item]);
      addBtn.disabled = false;
      if (ok) this.dialog.close();
    });
    refresh();
    this.dialog.showModal();
  }

  async add(items) {
    if (this.canOrder) {
      const label = this.orderLabel();
      items = items.map((i) => Object.assign({}, i, { properties: Object.assign({ 'Order for': label }, i.properties) }));
    }
    const res = await fetch(this.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      this.say(err.description || 'Sorry, that could not be added.');
      return false;
    }
    await this.refreshCart();
    this.say('Added to your order');
    this.queueSync();
    return true;
  }

  async changeLine(line, quantity) {
    const res = await fetch(this.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line, quantity })
    });
    if (res.ok) await this.refreshCart();
  }

  async refreshCart() {
    const res = await fetch(this.root + 'cart.js');
    if (!res.ok) return;
    const cart = await res.json();
    this.cart = cart;
    if (!this.modeLoaded) {
      this.modeLoaded = true;
      const saved = cart.attributes && cart.attributes['Order type'];
      if (saved === 'Pickup' || saved === 'Delivery') this.setMode(saved);
    }
    this.cartEmpty = cart.items.length === 0;
    this.bar.hidden = cart.item_count === 0;
    this.querySelector('.oo-bar-count').textContent = cart.item_count;
    this.querySelector('.oo-bar-total').textContent = this.cents(cart.total_price);
    this.querySelector('.oo-subtotal-value').textContent = this.cents(cart.total_price);
    const lines = this.querySelector('.oo-lines');
    this.syncCheckout();
    if (this.cartEmpty) {
      lines.innerHTML = '<p class="oo-empty">Your order is empty. Add something delicious.</p>';
      return;
    }
    lines.innerHTML = cart.items.map((item, index) => {
      const note = item.properties && item.properties.Notes ? '<small>' + this.esc(item.properties.Notes) + '</small>' : '';
      const variant = item.variant_title ? '<small>' + this.esc(item.variant_title) + '</small>' : '';
      return '<div class="oo-line">' +
        (item.image ? '<img alt="" src="' + this.esc(this.img(item.image, 160)) + '">' : '') +
        '<div class="oo-line-text"><strong>' + this.esc(item.product_title) + '</strong>' + variant + note +
          '<div class="oo-qty oo-qty--small">' +
            '<button type="button" data-line="' + (index + 1) + '" data-qty="' + (item.quantity - 1) + '" aria-label="Fewer">&minus;</button>' +
            '<output>' + item.quantity + '</output>' +
            '<button type="button" data-line="' + (index + 1) + '" data-qty="' + (item.quantity + 1) + '" aria-label="More">+</button>' +
          '</div></div>' +
        '<span class="oo-line-price">' + this.cents(item.final_line_price) + '</span>' +
      '</div>';
    }).join('');
  }
}

if (!customElements.get('order-online')) customElements.define('order-online', OrderOnline);
